/**
 * Component Registry for Axia Residential Arc Living Theme
 *
 * Extends the base preferred theme registry with Axia Residential Arc Living specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-preferred/registry';
import { AccessibilityStatement } from './components/AccessibilityStatement';
import { ContactUs } from './components/ContactUs';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { PreferredEmployerHero } from './components/PreferredEmployerHero';
import { PreferredEmployerProgram } from './components/PreferredEmployerProgram';
import { ReviewsCallout } from './components/ReviewsCallout';
import { ScheduleATour } from './components/ScheduleATour';
import { SitemapContent } from './components/SitemapContent';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';
import { TourSchedulerEmbed } from './components/TourSchedulerEmbed';

/**
 * Axia Residential Arc Living specific component overrides.
 * These components have been customized for the Axia Residential Arc Living brand.
 */
const axiaresidentialarclivingOverrides: Partial<ComponentRegistry> = {
  AccessibilityStatement,
  ContactUs,
  Footer,
  Header,
  PreferredEmployerHero,
  PreferredEmployerProgram,
  ReviewsCallout,
  ScheduleATour,
  SitemapContent,
  SpecialOfferBanner,
  TourSchedulerEmbed,
};

/**
 * Final merged registry for Axia Residential Arc Living properties.
 * Inherits all components from the preferred theme, with Axia Residential Arc Living overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...axiaresidentialarclivingOverrides,
};

export default registry;
